var scriptLoader = {};

var hasRequiredScriptLoader;

function requireScriptLoader () {
	if (hasRequiredScriptLoader) return scriptLoader;
	hasRequiredScriptLoader = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		(function (ScriptLoader) {
		    ScriptLoader.loadScript = function (options) {
		        var script;
		        script = document.createElement('script');
		        script.src = options.src;
		        if (options.id) {
		            script.id = options.id;
		        }
		        if (Boolean(options.async)) {
		            script.async = options.async;
		        }
		        if (Boolean(options.defer)) {
		            script.defer = options.defer;
		        }
		        if (options.onload) {
		            script.onload = options.onload;
		        }
		        document.body.appendChild(script);
		    };
		    ScriptLoader.LoadScriptAsync = function (options) {
		        return new Promise(function (resolve, reject) {
		            var script;
		            if (document.getElementById(options.id))
		                resolve();
		            script = document.createElement('script');
		            script.src = options.src;
		            script.id = options.id;
		            script.addEventListener('load', resolve);
		            script.addEventListener('error', function () { return reject('Error loading script.'); });
		            script.addEventListener('abort', function () { return reject('Script loading aborted.'); });
		            document.body.appendChild(script);
		        });
		    };
		})(exports.ScriptLoader || (exports.ScriptLoader = {}));
		
	} (scriptLoader));
	return scriptLoader;
}

export { requireScriptLoader as r };
